import React, { useState, useEffect } from 'react';
import AuthService from '../services/AuthService';
import {  useNavigate, NavLink} from 'react-router-dom';
import { toast } from 'react-toastify';

import ApiService from "../services/ApiService";
import AreaChart from "../components/AreaChart";

const Dashboard = () => {
  const navigate = useNavigate();
  
  const [isLoader, setIsLoader] = useState(false);
  const [stats, setStats] = useState([]);
  const [charts, setCharts] = useState([]);
  const [current_month, setCurrentMonth] = useState("");

useEffect(() => {
    const isAuthenticated = AuthService.getCurrentUser(); // Check if the user is authenticated
    if (!isAuthenticated) {
        navigate('/login');
    }
    getDashboard();

    const now = new Date();
    const options = { month: "short", year: "numeric" };
    const formattedDate = now.toLocaleDateString("en-US", options);
    setCurrentMonth(formattedDate);

}, [navigate]);


const getDashboard = async () => {
    try {
        setIsLoader(true);
        const response = await ApiService.request({
          method: "GET",
          url: "/getDashboard", // Replace with your API endpoint
        });
        const data = response.data;
        if (data.status) {
            setStats(data.data.stats);
            setCharts(data.data.charts);
        } else {
            toast.error(data.message);
        }
        setIsLoader(false);
    } catch (error) {
        setIsLoader(false);
    }
   
};

  return (
    <div className="d-flex flex-column flex-column-fluid">
      <div id="kt_app_toolbar" className="app-toolbar py-3 py-lg-6">
        <div
          id="kt_app_toolbar_container"
          className="app-container container-fluid d-flex flex-stack"
        >
          <div className="page-title d-flex flex-column justify-content-center flex-wrap me-3">
            <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">
              Dashboard
            </h1>
            <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
              <li className="breadcrumb-item text-muted">
                <a
                  href="/TimeLogger/admin/"
                  className="text-muted text-hover-primary"
                >
                
                  
                </a>
              </li>
              <li className="breadcrumb-item">
                <span className="bullet bg-gray-400 w-5px h-2px"></span>
              </li>
              <li className="breadcrumb-item text-muted"> Dashboard </li>
            </ul>
          </div>
          <div className="d-flex align-items-center gap-2 gap-lg-3"></div>
        </div>
      </div>

      <div id="kt_app_content" className="app-content flex-column-fluid">
        <div
          id="kt_app_content_container"
          className="app-container container-fluid"
        >
          <div className="row g-5 g-xl-10 mb-5 mb-xl-10">
            {/* <div className="col-xl-3 col-md-6 mb-4">
                        <NavLink to="/tests" className="card border bg-white shadow h-100 py-2">
                            <div className="card-body">
                                <div className="row no-gutters align-items-center">
                                    <div className="col mr-2">
                                        <div className="fs-6 fw-bold text-gray-900 text-uppercase mb-2"> Tests Listed </div>
                                        <div className="h1 mb-0 font-weight-bold text-gray-700">{stats?.total_tests}</div>
                                    </div>
                                    <div className="col-auto">
                                        <i className="bi bi-card-list fs-3x text-gray-400"></i>
                                    </div>
                                </div>
                            </div>
                        </NavLink>
                    </div> */}

            {/* <div className="col-xl-3 col-md-6 mb-4">
                        <NavLink to="/attempts?status=Active" className="card border bg-white shadow h-100 py-2">
                            <div className="card-body">
                                <div className="row no-gutters align-items-center">
                                    <div className="col mr-2">
                                        <div className="fs-6 fw-bold text-gray-900 text-uppercase mb-2"> Active Tests </div>
                                        <div className="h1 mb-0 font-weight-bold text-gray-700">{stats?.active_tests}</div>
                                    </div>
                                    <div className="col-auto">
                                        <i className="bi bi-card-text fs-3x text-gray-400"></i>
                                    </div>
                                </div>
                            </div>
                        </NavLink>
                    </div> */}
            {/* <div className="col-xl-3 col-md-6 mb-4">
                        <NavLink to="/attempts?status=Completed" className="card border bg-white shadow h-100 py-2">
                            <div className="card-body">
                                <div className="row no-gutters align-items-center">
                                    <div className="col mr-2">
                                        <div className="fs-6 fw-bold text-gray-900 text-uppercase mb-2"> Completed Tests </div>
                                        <div className="h1 mb-0 font-weight-bold text-gray-700">{stats?.completed_tests}</div>
                                    </div>
                                    <div className="col-auto">
                                        <i className="bi bi-card-checklist fs-3x text-gray-400"></i>
                                    </div>
                                </div>
                            </div>
                        </NavLink>
                    </div> */}

            <div className="col-xl-3 col-md-6 mb-4">
              <NavLink
                to="/events"
                className="card border bg-white shadow h-100 py-2"
              >
                <div className="card-body">
                  <div className="row no-gutters align-items-center">
                    <div className="col mr-2">
                      <div className="fs-6 fw-bold text-gray-900 text-uppercase mb-2">
                    
                        Total Events
                      </div>
                      <div className="h1 mb-0 text-gray-700 fw-bold">
                        {stats?.total_events}
                      </div>
                    </div>
                    <div className="col-auto">
                      <i className="bi bi-person-video fs-3x text-gray-400"></i>
                    </div>
                  </div>
                </div>
              </NavLink>
            </div>

            <div className="col-xl-3 col-md-6 mb-4">
              <NavLink
                to="/events?type=upcoming"
                className="card border bg-white shadow h-100 py-2"
              >
                <div className="card-body">
                  <div className="row no-gutters align-items-center">
                    <div className="col mr-2">
                      <div className="fs-6 fw-bold text-gray-900 text-uppercase mb-2">
                    
                        Upcoming Events
                      </div>
                      <div className="h1 mb-0 text-gray-700 fw-bold">
                        {stats?.upcoming_events}
                      </div>
                    </div>
                    <div className="col-auto">
                      <i className="bi bi-person-video fs-3x text-gray-400"></i>
                    </div>
                  </div>
                </div>
              </NavLink>
            </div>
            <div className="col-xl-3 col-md-6 mb-4">
              <NavLink
                to="/events?type=past"
                className="card border bg-white shadow h-100 py-2"
              >
                <div className="card-body">
                  <div className="row no-gutters align-items-center">
                    <div className="col mr-2">
                      <div className="fs-6 fw-bold text-gray-900 text-uppercase mb-2">
                    
                        Past Events
                      </div>
                      <div className="h1 mb-0 text-gray-700 fw-bold">
                        {stats?.past_events}
                      </div>
                    </div>
                    <div className="col-auto">
                      <i className="bi bi-person-video fs-3x text-gray-400"></i>
                    </div>
                  </div>
                </div>
              </NavLink>
            </div>

            <div className="col-xl-3 col-md-6 mb-4">
              <NavLink
                to="/users"
                className="card border bg-white shadow h-100 py-2"
              >
                <div className="card-body">
                  <div className="row no-gutters align-items-center">
                    <div className="col mr-2">
                      <div className="fs-6 fw-bold text-gray-900 text-uppercase mb-2">
                    
                        Total Users
                      </div>
                      <div className="h1 mb-0 text-gray-700 fw-bold">
                        {stats?.total_users}
                      </div>
                    </div>
                    <div className="col-auto">
                      <i className="bi bi-people fs-3x text-gray-400"></i>
                    </div>
                  </div>
                </div>
              </NavLink>
            </div>

            <div className="col-xl-3 col-md-6 mb-4">
              <NavLink
                to="/categories"
                className="card border bg-white shadow h-100 py-2"
              >
                <div className="card-body">
                  <div className="row no-gutters align-items-center">
                    <div className="col mr-2">
                      <div className="fs-6 fw-bold text-gray-900 text-uppercase mb-2">
                    
                        Interest Categories
                      </div>
                      <div className="h1 mb-0 font-weight-bold text-gray-700">
                        {stats?.total_categories}
                      </div>
                    </div>
                    <div className="col-auto">
                      <i className="bi bi-tag fs-3x text-gray-400"></i>
                    </div>
                  </div>
                </div>
              </NavLink>
            </div>

            <div className="col-xl-3 col-md-6 mb-4">
              <NavLink
                to="/packages"
                className="card border bg-white shadow h-100 py-2"
              >
                <div className="card-body">
                  <div className="row no-gutters align-items-center">
                    <div className="col mr-2">
                      <div className="fs-6 fw-bold text-gray-900 text-uppercase mb-2">
                    
                        Total Packages
                      </div>
                      <div className="h1 mb-0 font-weight-bold text-gray-700">
                        {stats?.total_packages}
                      </div>
                    </div>
                    <div className="col-auto">
                      <i className="bi bi-bookmarks fs-3x text-gray-400"></i>
                    </div>
                  </div>
                </div>
              </NavLink>
            </div>
            <div className="col-xl-3 col-md-6 mb-4">
              <NavLink
                to="/subscriptions"
                className="card border bg-white shadow h-100 py-2"
              >
                <div className="card-body">
                  <div className="row no-gutters align-items-center">
                    <div className="col mr-2">
                      <div className="fs-6 fw-bold text-gray-900 text-uppercase mb-2">
                    
                        Subscription Purchased
                      </div>
                      <div className="h1 mb-0 font-weight-bold text-gray-700">
                        {stats?.packages_purchased}
                      </div>
                    </div>
                    <div className="col-auto">
                      <i className="bi bi-bookmark-check fs-3x text-gray-400"></i>
                    </div>
                  </div>
                </div>
              </NavLink>
            </div>
          </div>

          <div className="row g-5 g-xl-10 mb-5 mb-xl-10">
            <div className="col-md-6">
              <div className="card card-flush overflow-hidden">
                <div className="card-header pt-5">
                  <h3 className="card-title align-items-start flex-column">
                    <span className="card-label fw-bold text-dark">
                      Users Stats
                    </span>
                    <span className="text-gray-400 mt-1 fw-semibold fs-6">
                      
                      Users registered per month
                    </span>
                  </h3>
                  <div className="card-toolbar"></div>
                </div>
                <div className="card-body d-flex align-items-end">
                  <div
                    className="p-chart h-300px w-100"
                    style={{ position: "relative" }}
                  >
                    <AreaChart
                      labels={charts.months}
                      label="Users"
                      dataset={charts.month_users}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="card card-flush overflow-hidden">
                <div className="card-header pt-5">
                  <h3 className="card-title align-items-start flex-column">
                    <span className="card-label fw-bold text-dark">
                    
                      {current_month} 
                    </span>
                    <span className="text-gray-400 mt-1 fw-semibold fs-6">
                      This Month Events
                    </span>
                  </h3>
                  <div className="card-toolbar"></div>
                </div>
                <div className="card-body d-flex align-items-end">
                  <div
                    className="p-chart h-300px w-100"
                    style={{ position: "relative" }}
                  >
                    <AreaChart
                      labels={charts.dates}
                      label="Events"
                      dataset={charts.events}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="card card-flush overflow-hidden">
                <div className="card-header pt-5">
                  <h3 className="card-title align-items-start flex-column">
                    <span className="card-label fw-bold text-dark">
                      Top Events By Joiners
                    </span>
                  </h3>
                  <div className="card-toolbar"></div>
                </div>
                <div className="card-body ">

                  {stats.top_events && stats.top_events.map((cat, index) => {
                    // Calculate percentage
                    const percentage = (cat?.members_count / stats.top_events[0].members_count) * 100;
                    
                    // Determine progress bar color based on percentage
                    let progressBarClass = "progress-bar progress-bar-striped fs-7";
                    if (percentage >= 90) {
                      progressBarClass += " bg-success";
                    } else if (percentage >= 70) {
                      progressBarClass += " bg-info";
                    } else if (percentage >= 50) {
                      progressBarClass += " bg-primary";
                    } else if (percentage >= 30) {
                      progressBarClass += " bg-warning";
                    } else {
                      progressBarClass += " bg-danger";
                    }

                    return (
                      <div className="row my-3" key={index}>
                        <div className="col-3">
                          <img 
                            src={cat?.image} 
                            className="w-30px h-30px bg-gray-300 p-1 rounded-circle mx-1" 
                            alt="img" 
                          />
                          {cat.title}
                        </div>
                        <div className="col-9">
                          <div className="progress mt-2" style={{height: '15px'}}>
                            <div 
                              className={progressBarClass}
                              role="progressbar" 
                              style={{width: `${percentage}%`}} 
                              aria-valuenow={percentage} 
                              aria-valuemin="0" 
                              aria-valuemax="100"
                            >
                              {cat?.members_count} Joiners
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}


                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="card card-flush overflow-hidden">
                <div className="card-header pt-5">
                  <h3 className="card-title align-items-start flex-column">
                    <span className="card-label fw-bold text-dark">
                      Top Interest Categories
                    </span>
                  </h3>
                  <div className="card-toolbar"></div>
                </div>
                <div className="card-body ">

                  {stats.top_interests && stats.top_interests.map((cat, index) => {
                    // Calculate percentage
                    const percentage = (cat?.user_count / stats.top_interests[0].user_count) * 100;
                    
                    // Determine progress bar color based on percentage
                    let progressBarClass = "progress-bar progress-bar-striped fs-7";
                    if (percentage >= 90) {
                      progressBarClass += " bg-success";
                    } else if (percentage >= 70) {
                      progressBarClass += " bg-info";
                    } else if (percentage >= 50) {
                      progressBarClass += " bg-primary";
                    } else if (percentage >= 30) {
                      progressBarClass += " bg-warning";
                    } else {
                      progressBarClass += " bg-danger";
                    }

                    return (
                      <div className="row my-3" key={index}>
                        <div className="col-3">
                          <img 
                            src={cat.category?.image} 
                            className="w-30px h-30px bg-gray-300 p-1 rounded-circle mx-1" 
                            alt="img" 
                          />
                          {cat.category?.title}
                        </div>
                        <div className="col-9">
                          <div className="progress mt-2" style={{height: '15px'}}>
                            <div 
                              className={progressBarClass}
                              role="progressbar" 
                              style={{width: `${percentage}%`}} 
                              aria-valuenow={percentage} 
                              aria-valuemin="0" 
                              aria-valuemax="100"
                            >
                              {cat?.user_count} Users
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}


                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="card card-flush overflow-hidden">
                <div className="card-header pt-5">
                  <h3 className="card-title align-items-start flex-column">
                    <span className="card-label fw-bold text-dark">
                      Top Regions By Users
                    </span>
                  </h3>
                  <div className="card-toolbar"></div>
                </div>
                <div className="card-body ">

                  {stats.top_regions && stats.top_regions.map((cat, index) => {
                    // Calculate percentage
                    const percentage = (cat?.user_count / stats.top_regions[0].user_count) * 100;
                    
                    // Determine progress bar color based on percentage
                    let progressBarClass = "progress-bar progress-bar-striped fs-7";
                    if (percentage >= 90) {
                      progressBarClass += " bg-success";
                    } else if (percentage >= 70) {
                      progressBarClass += " bg-info";
                    } else if (percentage >= 50) {
                      progressBarClass += " bg-primary";
                    } else if (percentage >= 30) {
                      progressBarClass += " bg-warning";
                    } else {
                      progressBarClass += " bg-danger";
                    }

                    return (
                      <div className="row my-3" key={index}>
                        <div className="col-3">
                          {cat.timezone}
                        </div>
                        <div className="col-9">
                          <div className="progress mt-2" style={{height: '15px'}}>
                            <div 
                              className={progressBarClass}
                              role="progressbar" 
                              style={{width: `${percentage}%`}} 
                              aria-valuenow={percentage} 
                              aria-valuemin="0" 
                              aria-valuemax="100"
                            >
                              {cat?.user_count} Users
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}


                </div>
              </div>
            </div>


          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
